import React from 'react'
import useStyles from './styles'
import Box from '@material-ui/core/Box'
import Logo from 'assets/images/dokify-logo-black.svg'
import Link from '@material-ui/core/Link'
import Container from '@material-ui/core/Container'

const LandingFooter = () => {
  const classes = useStyles()

  return (
    <Box component="footer" className={classes.root}>
      <Container className={classes.footer}>
        <Box className={classes.links}>
          <Link
            href="https://dokify.net/app/terminos-y-condiciones"
            target="_blank"
            rel="noopener noreferrer"
            variant="body2"
            className={classes.link}
          >
            <span role="img" aria-label="" className={classes.linkIcon}>
              📝
            </span>{' '}
            Términos y condiciones
          </Link>
          <Link
            href="https://dokify.net/politica-de-privacidad"
            target="_blank"
            rel="noopener noreferrer"
            variant="body2"
            className={classes.link}
          >
            <span role="img" aria-label="" className={classes.linkIcon}>
              👩🏽‍💼
            </span>{' '}
            Políticas
          </Link>
          <Link
            href="https://dokify.net/aviso-legal"
            target="_blank"
            rel="noopener noreferrer"
            variant="body2"
            className={classes.link}
          >
            <span role="img" aria-label="" className={classes.linkIcon}>
              🧑🏻‍⚖️
            </span>{' '}
            Aviso legal
          </Link>
        </Box>
        <img className={classes.logo} src={Logo} alt="Dokify" />
      </Container>
    </Box>
  )
}

export default LandingFooter
